import Image from "@/ui/Image";
import classes from "./styles.module.scss";
import Plus from "@/assets/Plus.svg";
import Link from "next/link";

const BlogCard = ({ blog, className }) => {

  function generateBlogType(blogType) {
    if(typeof blogType === 'string') {
      return <div className={`${classes.blogType}`}>{blogType}</div>
    } else if(Array.isArray(blogType)) {
      return blogType.map((_item, index) => {
        return <div key={index} className={`${classes.blogType}`}>{_item}</div>
      })
    } else {
      return <></>
    }
  }

  return (
    <Link className={`${classes.card} ${className}`} href={`/blogs/${blog.url_slug}/`}> {/* Use classes from styles module */}
      <div className={classes.cardImg}> {/* Use classes from styles module */}
        <Image img={blog.image} size="590x340" alt={blog.title} />
      </div>
      <div className={classes.card_details}>
        <div className={classes.cardContent}> {/* Use classes from styles module */}
          <div className={classes.details}>
            <div className={classes.blog_types}>
              {
                generateBlogType(blog.blog_type)
              }
            </div>


            <div className={classes.date}>{blog.publish_date}</div>
          
          </div>
          
          <h5 className={classes.title}>{blog.title}</h5>
      </div>
      

        <div className={classes.readMoreContainer}>
          <div className={classes.readMore}>
            {'Read More'}
          </div>
          <Plus width={30} height={30} className={`fill tertiary ${classes.icon}`} />
        </div>
      </div>

    </Link>
  );
}

export default BlogCard;
